const OPEN_CART_EVENT_NAME = "me-qr-menu:cart:open";

export const emitOpenCart = () => {
  window.dispatchEvent(new Event(OPEN_CART_EVENT_NAME));
};

export const subscribeOpenCart = (callback: () => void) => {
  const handler = () => callback();
  window.addEventListener(OPEN_CART_EVENT_NAME, handler);
  return () => window.removeEventListener(OPEN_CART_EVENT_NAME, handler);
};
